import { gql } from "@apollo/client";

export const GET_INDICACIONES_BY_ID_EVALUACION = gql`
  query getIndicacionesByIdEvaluacion($idEvaluacion: Int!) {
    indicacionesByIdEvaluacion(idEvaluacion: $idEvaluacion) {
      success
      error
      valorEsperado {
        idIndicacion
        idEvaluacion
        fechaDesde
        fechaHasta
        fechaAlta
        solicitudEnCurso
      }
    }
  }
`;